
import React, { useEffect, useState } from 'react';
import { Flex, SwipeAction, List, InputItem, Button, Accordion, Icon, Toast, Modal } from 'antd-mobile';
import { Error, Loading } from '../components';
import { GetCompanyInfo, GetAccountInfo } from '../../../api/request'
import { CreateCustomer } from '../../../api/usms';
// const dataSource = new ListView.DataSource({
//   rowHasChanged: (row1, row2) => row1 !== row2,
// });

const alert = Modal.alert;

// 搜索出来的列表
function CustomerInfoList(props) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [search, setSearch] = useState('');
  const [companyList, setCompanyList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [accountLoading, setAccountLoading] = useState(false);

  const { callback } = props;

  // const dataSourceList = useMemo(() => dataSource.cloneWithRows(companyList), [companyList]);

  const getCompanyInfo = (searchKey) => {
    setLoading(true);
    const data = {
      CompanyId: searchKey ? [+searchKey] : undefined,
    };
    // if (Number(searchKey) > 0) {
    //   data.CompanyId = [+searchKey];
    // }
    GetCompanyInfo(data).then((res) => {
      if (res.RetCode === 0) {
        const list = res.Data || [];
        setLoading(false);
        setCompanyList(list);
        setErrorMessage(null);
      } else {
        setLoading(false);
      }
    }).catch(e => {
      setLoading(false);
      setErrorMessage(e.message || "获取数据失败")
    });;
  };

  const handleSearch = (value) => {
    getCompanyInfo(value);
  };

  const handleCompanyOpen = (key, company) => {
    if (company && company.CompanyId >= 0) {
      if (key >= 0) {
        setAccountLoading(true);
        GetAccountInfo({
          CompanyId: [+company.CompanyId], // CompanyId
        }).then((ores) => {
          if (ores.RetCode === 0) {
            setAccountList(ores.Data || []);
          }
          setAccountLoading(false);
        });
      } else {
        setAccountList([]);
      }
    }
  }

  const AccountRow = ({ item }) => {
    return (
      <SwipeAction
        autoClose
        right={[
          {
            text: '添加',
            onPress: () => {
              alert('确认添加', `确定添加用户 ${item.AccountName}(${item.AccountId}) 吗?`, [
                { text: 'Cancel', onPress: () => {} },
                { text: 'Ok', onPress: () => {
                  handleCommit({
                    AccountId: [+item.AccountId],
                    CompanyId: +item.CompanyId
                  })
                } },
              ])
            },
            style: { backgroundColor: '#108ee9', color: 'white' },
          },
        ]}
      >
        <List.Item
          extra={<span style={{ fontSize: '12px' }}>左滑操作</span>}
          wrap
          arrow="horizontal"
          style={{ background: 'aliceblue' }}
          onClick={() => { }}
        >
          <div style={{ fontSize: '14px', width: '100%', }}>
            AccountId: {item.AccountId ? `${item.AccountName}(${item.AccountId})` : '-'}
          </div>
        </List.Item>
      </SwipeAction>
    )
  }

  const handleCommit = (data) => {
    setAccountLoading(true);
    CreateCustomer(data).then((res) => {
      setAccountLoading(false);
      if (res.RetCode === 0) {
        Toast.success("添加成功", 2, null, false);
        callback && callback();
      } else {
        Toast.fail(res.Error || '出错啦！',  2, null, false);
      }
    });
  }

  useEffect(() => {
    getCompanyInfo();
  }, []);

  return <div style={{ width: '100%' }}>
    <Flex style={{ width: '100%', paddingRight: '8px' }}>
      <Flex.Item style={{ padding: '1px', flex: 1 }}>
        <InputItem
          type={'text'}
          placeholder="通过公司ID搜索"
          clear
          style={{ fontSize: '12px' }}
          onChange={(v) => setSearch(v)}
          moneyKeyboardWrapProps={{
            onTouchStart: e => e.preventDefault()
          }}
        ></InputItem>
      </Flex.Item>
      <Flex.Item style={{ padding: '1px', flex: 0, minWidth: '85px' }}>
        <Button
          type="primary"
          size='small'
          style={{ fontSize: '12px' }}
          onClick={() => handleSearch(search)}
          loading={loading}>用户搜索</Button>
      </Flex.Item>
    </Flex>
    <Loading loading={loading} style={{ width: '100%' }}>
      {errorMessage ?
        <Error message={errorMessage} /> : <>
          <Accordion accordion className='custom' onChange={key => handleCompanyOpen(key, companyList[key])}>
            {companyList.map((item, index) => {
              return <Accordion.Panel key={index} header={<List.Item
                wrap
                multipleLine
                arrow="empty"
              // onClick={() => {}}
              >
                <div style={{ fontWeight: 'bold', fontSize: '16px', width: '100%' }}>{item.Email || '(邮箱不存在)'}</div>
                <div style={{ fontSize: '14px', width: '100%', color: '#aaa' }}>
                  CompanyID: {item.CompanyId || '-'} <br />
                  名称：{item.CompanyName || item.DisplayName || '(无公司名称)'} <br />
                  {/* AccountId: {item.AccountId ? `${item.AccountName}(${item.AccountId})` : '-'} */}
                </div>
              </List.Item>}>
                <Loading loading={accountLoading} style={{ width: '100%' }}>
                  <List>
                    {accountList.map((item, index) => {
                      return <AccountRow item={item} key={index} />
                    })}
                    {accountList.length === 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '12px', fontSize: '12px', color: 'red' }}>
                          <Icon type='cross-circle' />
                          <span>当前 Company 下没有 Account</span>
                      </div>
                    ) : null}
                  </List>
                </Loading>
              </Accordion.Panel>
            })}
            {/* <ListView
            ref={listRef}
            initialListSize={5}
            dataSource={dataSourceList}
            renderRow={row}
            style={{
              minHeight: '500px',
              overflowY: 'auto'
            }}
            pageSize={5}
            scrollRenderAheadDistance={200}
          /> */}
          </Accordion>
        </>
      }
    </Loading>
  </div>
}

export default CustomerInfoList